import { nameField } from './nameField';

export const commonBaseForm = {
  sections: [{ sectionTitle: null, items: [nameField] }],
};
